export const DEVICE_DETAIL_INTERVAL = 5000
export const DEVICE_CONNECTED_CUTOFF = 20000
export const JAMMED_SIGNAL_VALUE = 5
export const LOW_SIGNAL_VALUE = 15
export const DATETIME_FORMAT = 'yyyy/L/d HH:mm:ss'
